import { ClientLinkQrCodeDialogStructure } from "../store";
import { CLIENT_LINK_QRCODE_DIALOG } from '../actions-constants/clientLinkQrCodeDialog.constants'
const initialClientLinkQrCodeDialogStructure: ClientLinkQrCodeDialogStructure = new ClientLinkQrCodeDialogStructure



export function clientLinkQrCodeDialogReducer(clientLinkQrCodeDialog: ClientLinkQrCodeDialogStructure = initialClientLinkQrCodeDialogStructure, action): ClientLinkQrCodeDialogStructure {

  switch (action.type) {
    case CLIENT_LINK_QRCODE_DIALOG.SET_INITIAL_SHOW:
      return {
        ...clientLinkQrCodeDialog,
        show: action.show
      }

    case CLIENT_LINK_QRCODE_DIALOG.SET_INITIAL_QRCODE_API_URL:
      return {
        ...clientLinkQrCodeDialog,
        qrCodeApiUrl: action.qrCodeApiUrl
      }

    case CLIENT_LINK_QRCODE_DIALOG.SET_INITIAL_QRCODE_API_URL_LINK:
      return {
        ...clientLinkQrCodeDialog,
        qrCodeApiUrlLink: action.qrCodeApiUrlLink
      }


    default:
      return clientLinkQrCodeDialog
  }
}